import { connect } from 'react-redux';
import { loadMyWalls, deleteMyWall } from 'arts/actions/my_walls';
import MyWalls from './my_walls';

const mapStateToProps = ({ myWalls }) => myWalls;

export default connect(mapStateToProps, { loadMyWalls, deleteMyWall })(MyWalls);
